import React from 'react';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-58">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#E67E22 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-59"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-61">
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-62">
            No Dejes que Otro Lunes te Destruya
          </h2>

          <div className="space-y-6 text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-63">
            <p data-id="element-64">
              La paz mental no es un lujo reservado para los que ganan más o
              trabajan menos. Es tu derecho básico como ser humano.
            </p>
            <p data-id="element-65">
              Hoy tienes la oportunidad de cambiar el patrón. Por el precio de
              una salida al cine para dos personas, puedes tener el sistema
              completo que te enseña a recuperar el control de tu vida laboral y
              personal.
            </p>
            <p className="font-bold text-white text-2xl mt-8" data-id="element-66">
              El próximo Marzo puede ser diferente. Pero solo si actúas hoy.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-67">
            <a href="https://www.merlanis.com/cart/53871355822448:1" className="w-full sm:w-auto bg-orange hover:bg-orange-500 text-white font-bold text-xl py-5 px-10 rounded-xl shadow-[0_0_20px_rgba(230,126,34,0.4)] transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(230,126,34,0.6)]" data-id="element-68">
              SÍ, QUIERO CÓDIGO CALMA POR $6.390 CLP
            </a>
            <div className="flex items-center gap-2 text-sm text-gray-400 mt-3" data-id="element-69">
              <Lock size={16} data-id="element-70" />
              <span data-id="element-71">
                Pago seguro vía Mercado Pago. Acceso inmediato. Garantía de 7
                días.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}